export const seoKeywords = {
  name: 'keywords',
  content:
    'AI chatbot design, AI chatbot architecture, OpenAI custom chatbot, AI chatbot consultancy, conversational AI development',
};

export const aiChatServicePageSeo = {
  title: 'Custom AI chatbot development company | Rumble Fish',
  meta: [
    seoKeywords,
    {
      name: 'description',
      content:
        'Rumble Fish excels in building custom AI-powered chat assistants.  AI chatbot design, AI chatbot architecture, OpenAI custom chatbot, AI chatbot consultancy, conversational AI development - we cover it all!',
    },
  ],
};
